import { AppState } from '../store';

export const enrollCustomerStateSelector = (state: AppState) =>
  state.customer.enrollCustomerState;

export const customerSelector = (state: AppState) => state.customer.customer;

export const pointBalanceSelector = (state: AppState) =>
  state.customer.pointBalance;

export const isCustomerAddedToSaleSelector = (state: AppState) =>
  state.customer.isAddedToSale;

export const addCustomerToSaleStateSelector = (state: AppState) =>
  state.customer.addCustomerToSaleState;

export const removeCustomerFromSaleStateSelector = (state: AppState) =>
  state.customer.removeCustomerFromSaleState;

export const customerContextSelector = (state: AppState) =>
  state.customer.context;

export const getCustomerStateSelector = (state: AppState) =>
  state.customer.getCustomerState;
